import React from 'react';
import styles from './LegalLayout.module.css';

interface Props {
  title: string;
  children: React.ReactNode;
}

const LegalLayout: React.FC<Props> = ({ title, children }) => (
  <main className={styles.page}>
    <div className={styles.container}>
      <h1>{title}</h1>
      {children}
    </div>
  </main>
);

export default LegalLayout;
